import { FC } from "react";

import importFailure from "../../../assets/fonts/importFailure.svg";
import { Notification } from "../../../types/global/types";
import "./styles.scss";

type Props = {
  notification: Notification;
};

type RowError = {
  row: number;
  reason: string;
};

export const ImportAbortedNotification: FC<Props> = ({ notification }) => {
  const notes = notification.notes as any;
  const rowErrors: RowError[] | undefined = notes?.row_errors;
  const hasRowErrors = Array.isArray(rowErrors) && rowErrors.length > 0;

  // total_errors may be absent on notifications created before this field was added
  const totalErrors: number = notes?.total_errors ?? rowErrors?.length ?? 0;
  const displayedCount = hasRowErrors ? rowErrors!.length : 0;
  const overflowCount = totalErrors - displayedCount;

  return (
    <div className="notification">
      <div className="notification__header">
        <div className="notification__reaction">
          <img src={importFailure} alt={"importFailureIcon"} />
        </div>
        <div className="notification__title">
          <h3 style={{ color: "#c0392b" }}>
            {notification.title.startOfTitle}
            {notification.title.householdName}
          </h3>
          {notification.title.endOfTitle && (
            <div className="notification__import-error-summary" style={{ color: "#c0392b", marginTop: 4 }}>
              {notification.title.endOfTitle}
            </div>
          )}
          {hasRowErrors && (
            <div className="notification__import-row-errors" style={{ marginTop: 6 }}>
              {rowErrors!.slice(0, 10).map((err, idx) => (
                <div key={idx} style={{ fontSize: "0.85em", color: "#c0392b" }}>
                  Row {err.row}: {err.reason}
                </div>
              ))}
              {overflowCount > 0 && (
                <div style={{ fontSize: "0.85em", color: "#c0392b" }}>
                  And {overflowCount} more {overflowCount === 1 ? "line" : "lines"} with errors. Please fix the file and try again.
                </div>
              )}
            </div>
          )}
          <div className="notification__time">
            {notification.created_at_formatted}
          </div>
        </div>
      </div>
    </div>
  );
};
